import { render, staticRenderFns } from "./protesto_detalhe.vue?vue&type=template&id=1fce86a0&scoped=true"
import script from "./protesto_detalhe.vue?vue&type=script&lang=js"
export * from "./protesto_detalhe.vue?vue&type=script&lang=js"
import style0 from "./protesto_detalhe.vue?vue&type=style&index=0&id=1fce86a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce86a0",
  null
  
)

export default component.exports